import { Link } from "react-router-dom"
import { companyName } from "../../../app/store/constant"
import { Body3, Body2 } from "../../../themes/typography"

export default function LogoutFooter() {
    return (
        <div className="check-in-staff-logout-footer-container">

            <div className="company-copyright-and-socials-details">
                <div className="company-copyright-details">
                    <Body2 fontWeight={400}>
                        © 2025 <Link href="/" className="company-link">
                            {companyName}
                        </Link>. All rights reserved.
                    </Body2>
                </div>
            </div>

            <div className="company-policies-details">
                <Body3 fontWeight={350}>
                    <Link to="/pages/privacy-policy" className="footer-policy-link" target="_blank">
                        Privacy Policy
                    </Link>
                </Body3>
                <Body3 fontWeight={350}>
                    <Link to="/pages/terms-and-conditions" className="footer-policy-link" target="_blank">
                        Terms & Conditions
                    </Link>
                </Body3>
                {/* <Body3 fontWeight={350}>
                    <Link to="#" className="footer-policy-link">
                        Contact Us
                    </Link>
                </Body3>
                <Body3 fontWeight={350}>
                    <Link to="#" className="footer-policy-link">
                        Refund & Cancellation Policy
                    </Link>
                </Body3> */}
            </div>

            <div className="company-policies-details">
                <Body3 fontWeight={350}>
                    <Link to="/pages/contact-us" className="footer-policy-link" target="_blank">
                        Contact Us
                    </Link>
                </Body3>
                <Body3 fontWeight={350}>
                    <Link to="/pages/refund-policy" className="footer-policy-link" target="_blank">
                        Refund & Cancellation Policy
                    </Link>
                </Body3>
            </div>

        </div>
    )
}